export class PermissionConstants {
  //Dashboard
  static readonly canViewTenantDashboard = 'Dashboard.CanViewTenantDashboard';
  static readonly canViewWallboard = 'Dashboard.CanViewWallboard';
  /**
   * Create, update and delete wallboard presentations. Reading them only needs `canViewWallboard`;
   * the server demands both for every write.
   */
  static readonly canManageWallboardPresentations = 'Dashboard.ManageWallboardPresentations';

  /**
   * Either Dashboard tab is enough to reach `/dashboard`.
   *
   * The two permissions are independent siblings on the server, so a role may carry only the wallboard
   * one. Gating the menu entry on the overview permission alone hid the Dashboard item outright from such
   * a role, leaving `/dashboard/wallboard` reachable only by typing it.
   */
  static readonly anyDashboardTabPermission = [
    PermissionConstants.canViewTenantDashboard,
    PermissionConstants.canViewWallboard,
  ].join('||');

  //AgentDesktop
  static readonly canViewAgentDesktop = 'AgentDesktop.CanViewAgentDesktop';

  //Contacts
  static readonly canViewContacts = 'CrmContact.CanViewContacts';
  static readonly canViewContactDetail = 'CrmContact.CanViewContactDetail';
  static readonly canViewSegments = 'CrmContact.CanViewSegments';
  static readonly canEditSegments = 'CrmContact.CanEditSegments';
  static readonly canEditContacts = 'CrmContact.CanEditContacts';
  static readonly canExportContacts = 'CrmContact.CanExportContacts';
  static readonly canImportContacts = 'CrmContact.CanImportContacts';

  //Settings
  static readonly canManageDataImport = 'SettingManagement.CanManageDataImport';
  static readonly canManageDidRouting = 'SettingManagement.CanManageDidRouting';
  static readonly canManageCrmSettings = 'SettingManagement.CanManageCRMSettings';
  static readonly canManageWorkEnvironmentSettings = 'SettingManagement.CanManageWorkEnvironmentSettings';
  static readonly agentManagement = 'SettingManagement.AgentManagement';
  static readonly canManageWrapUpCodes = 'SettingManagement.CanManageWrapUpCodes';
  static readonly canManageDeclineReasons = 'SettingManagement.CanManageDeclineReasons';
  static readonly canManageLocalizationSettings =
    'SettingManagement.CanManageLocalizationSettings';
  static readonly canViewHolidayCalendar = 'SettingManagement.CanViewHolidayCalendar';
  static readonly canManageHolidayCalendar = 'SettingManagement.CanManageHolidayCalendar';
  static readonly canManageScheduledCallSettings = 'SettingManagement.CanManageScheduledCallSettings';
  static readonly canManageTelephonyInstances = 'SettingManagement.CanManageTelephonyInstances';
  static readonly canManageIntegrationSettings = 'SettingManagement.CanManageIntegrationSettings';

  static readonly localizationSettingsTab = [
    PermissionConstants.canManageLocalizationSettings,
    PermissionConstants.canViewHolidayCalendar,
  ].join('||');

  //Conversations
  static readonly canViewConversations = 'Conversations.CanViewConversations';
  static readonly canViewScheduledCalls = 'Conversations.CanViewScheduledCalls';
  static readonly canManageScheduledCalls = 'Conversations.CanManageScheduledCalls';

  //Outbound Campaigns
  static readonly canViewCampaigns = 'Outbound.CanViewCampaigns';
  static readonly canManageCampaigns = 'Outbound.CanManageCampaigns';
  static readonly canViewCampaignOverview = 'Outbound.CanViewCampaignOverview';
  static readonly canViewCampaignContacts = 'Outbound.CanViewCampaignContacts';
  static readonly canViewCampaignActivityLog = 'Outbound.CanViewCampaignActivityLog';
  static readonly canViewCampaignPipelineHealthOverview =
    'Outbound.CanViewCampaignPipelineHealthOverview';

  //Administration
  static readonly administrationPermissions = [
    'AbpIdentity.Roles',
    'AbpIdentity.Users',
    'AbpIdentity.ClaimTypes',
    'AbpIdentity.OrganizationUnits',
    'AbpIdentity.SecurityLogs',
    'Saas.Tenants',
    'Saas.Editions',
    'AuditLogging.AuditLogs',
    'LanguageManagement.Languages',
    'LanguageManagement.LanguageTexts',
    'OpenIddictPro.Application',
    'OpenIddictPro.Scope',
    'TextTemplateManagement.TextTemplates',
    'SettingManagement.Emailing',
    'SettingManagement.CanManageDataImport',
    'SettingManagement.CanManageDidRouting',
    'SettingManagement.CanManageWorkEnvironmentSettings',
    'SettingManagement.AgentManagement',
    'SettingManagement.CanManageLocalizationSettings',
    'SettingManagement.CanViewHolidayCalendar',
    'SettingManagement.CanManageScheduledCallSettings',
    PermissionConstants.canManageTelephonyInstances,
    PermissionConstants.canManageIntegrationSettings,
  ] as const;

  static readonly anyAdministrationPermission =
    PermissionConstants.administrationPermissions.join('||');
}
